<template>
  <div class="stay-effect":style="{height: collapse ? '50px': '134px'}">
    <div class="stay-effect-header" @click="collapse = !collapse">
      <span>停留特效</span>
      <i></i>
    </div>
    <div class="stay-effect-content">
      <div v-for="(item, key) in effectSelect">
        <div :class="{active: item.selected, 'effect-select': true}" @click="setEffect($event, item, key)">
          <i class="is-short" :class="{[`icon-${item.type}-anim`]: true}"></i>
        </div>
        <span class="effect-name">{{item.text}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    updateData: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data() {
    return {
      collapse: false,
      sprite: null,
      type: '',
      effectSelect: [
        {text: '无', type: 'None', selected: false},
        {text: '路径', type: 'path', selected: false},
        {text: '旋转', type: 'Whirl', selected: false},
        {text: '抖动', type: 'Shake', selected: false},
      ],
      ANALYSIS: {
        None : {category:'stay_animation_quick_panel', action:'click_empty_animatation', label:'停留动画快捷入口_无动画'},
        path : {category:'stay_animation_quick_panel', action:'click_route_animatation', label:'停留动画快捷入口_路径动画'},
        Whirl : {category:'stay_animation_quick_panel', action:'click_rotate_animatation', label:'停留动画快捷入口_旋转动画'},
        Shake : {category:'stay_animation_quick_panel', action:'click_shake_animatation', label:'停留动画快捷入口_抖动动画'},
      }
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectSprites_Msg',
      'SelectScenes_Msg',
    ]),
  },
  watch: {
    'updateData'(val, oldVal) {
      this.initData();
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.sprite = this.SelectSprites_Msg[0]
      let effect = this.sprite.effect;
      if (effect.pathAnim.end) {
        this.type = 'path';
      } else {
        this.type = effect.stayAnim.type;
      }
      this.effectSelect.forEach((val, k) => {
        val.selected = false;
        val.type === this.type && (val.selected = true);
      })
    },
    setEffect(e, item, key) {
      let code = this.sprite.effect.code;
      let data = {};
      if(this.isSpecialEffect(code)) {
        data = {
          code: 'FadeIn',
          entranceAnim:{
            start: this.sprite.effect.entranceAnim.start,
            end: this.sprite.effect.entranceAnim.end
          },
        }
      }

      this[item.type + 'AnimSet'](item.selected, data);

      this.$bus.emit('updateEffect_vue', {
        sprite: this.sprite,
        effect: this.sprite.effect || {},
        type: 'path'
      });
      this.$emit('changeData')
      this.$analysis(this.ANALYSIS[item.type])
    },
    pathAnimSet(select, data) {
      if(select) return;
      let start = this.sprite.effect.entranceAnim.end,
          end = start + 2000;
      end > this.sprite.effect.exitAnim.start && (end = this.sprite.effect.exitAnim.start);
      if (end <= start) {
        end = start + 500;
      }
      let { positionTop: y, positionLeft: x, width: w, height: h, rotate } = this.sprite;
      data.pathAnim = {
        start: start,
        end: end,
        scale: this.sprite.editor.scale,
        target: {
          x: x + 100,
          y: y + 100,
          rotate,
          w: w,
          h: h
        }
      }
      data.stayAnim = {
        type: 'None'
      }
      this.sprite.updateEffect(data, true)

      this.$bus.emit('settingPopup.hideSpriteBtn');
      this.$bus.emit('FeaturesPop_close_vue', { type: 3 })
    },
    WhirlAnimSet (select, data) {
      if(this.sprite.effect.stayAnim.type !== 'Whirl') {
        data.pathAnim = null;
        data.stayAnim = {
          type: 'Whirl',
          position: {
            top: .5,
            left: .5
          },
          speed: 1.05,
          ccw: false
        }
        this.sprite.updateEffect(data, true).then(() =>{
          this.sprite.changeStyle()
        })
      }
      this.$bus.emit('FeaturesPop_vue',{
        type: 1,
        name: 'effectSetting',
        sprite: this.sprite,
        contentType: 'whirl'
      });
    },
    ShakeAnimSet (select, data) {
      if(this.sprite.effect.stayAnim.type !== 'Shake') {
        data.pathAnim = null;
        data.stayAnim = {
          type: 'Shake',
          speed: 2,
          direction: 0,
          amplitude: .25
        }
        this.sprite.updateEffect(data, true).then(() =>{
          this.sprite.changeStyle()
        });
      }
      this.$bus.emit('FeaturesPop_vue',{
         type: 1,
        name: 'effectSetting',
        sprite: this.sprite,
        contentType: 'shake'
      });
    },
    NoneAnimSet () {
      this.sprite.updateEffect({pathAnim: null, stayAnim: {type: 'None'}}, true).then(() =>{
        this.sprite.changeStyle()
      });
    },
    isDrawEffect (code) {
      return /^(?:draw|hand|write)$/i.test('' + code);
    },
    isAppearEffect (code) {
      return /^(?:appear|type|bounce|roll)$/i.test('' + code);
    },
    isSpecialEffect (code) {
      return this.isDrawEffect(code) || this.isAppearEffect(code);
    }
  }
}
</script>

<style lang="scss" scoped>
.stay-effect {
  width: 100%;
  transition: all 0.3s;
  border-bottom: 1px solid #D4D4E7;
  overflow: hidden;
}
.stay-effect-header {
  display: flex;
  height: 50px;
  line-height: 50px;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  color: #474261;
  cursor: pointer;
}
.stay-effect-content{
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > div {
    text-align: center;
    font-size: 13px;
  }

  .effect-select {
    margin: 0 auto;
    width: 46px;
    height: 46px;
    background-color: #f0f0f8;
    border-radius: 4px;
    margin-bottom: 7px;
    line-height: 56px;
    text-align: center;
    border: 2px solid transparent;
    cursor: pointer;
    overflow: hidden;

    // &:hover{
      // border-color: #5778fb;
    // }
  }

  .effect-select.active {
    border-color: #5778fb;
  }

  .icon-None-anim {
    position: relative;
    right: -50%;
    background: #FF293D;
    width: 2px;
    height: 102%;
    display: block;
    transform: skew(-45deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/settingPanel/stayEffect.vue